import { PrintDocument, printHtml, render, resolveParams } from '@iws/pos-devices'

/** Prints a document (A4 label or card sheet) through the browser's print dialog, on any printer (POS.md §18.9). */
export const printSheet = (doc: PrintDocument, title: string) => {
  const out = render('html', doc, resolveParams('html'), { title })
  if ('text' in out) return printHtml(out.text)
}
